import React, { useState } from 'react'
import styles from './responsive_table.module.css'

export default function DataRow({ columns, rowClasses, onRowClick, rowData }) {
  const [expanded, setExpanded] = useState(false)

  const toggleExpanded = e => {
    e.stopPropagation()
    setExpanded(!expanded)
  }

  let computedRowClasses = typeof rowClasses === 'function' ? rowClasses(rowData) : rowClasses.toString()

  return (
    <>
      {/* RIGA PRINCIPALE */}
      <div
        className={`d-flex align-items-center ${styles.row} ${computedRowClasses}`}
        onClick={() => {
          if (onRowClick) onRowClick(rowData)
        }}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        {columns.map((col, i) => {
          if (i === 0 && rowData.children && rowData.children.length > 0) {
            // Prima colonna con icona espansione
            return (
              <div key={`col-${i}`} className={col.className} onClick={toggleExpanded}>
                {expanded ? (
                  <i className="fas fa-minus-square" aria-label="Collapse row" />
                ) : (
                  <i className="fas fa-plus-square" aria-label="Expand row" />
                )}
                <span>{typeof col.data === 'string' ? rowData[col.data] : null}</span>
              </div>
            )
          }
          const DataRenderer = col.data
          return (
            <div
              key={`col-${i}`}
              style={{
                ...col.style,
              }}
              className={col.className}>
              {typeof DataRenderer === 'string' ? (
                rowData[DataRenderer]
              ) : typeof DataRenderer === 'function' ? (
                <DataRenderer rowData={rowData} />
              ) : null}
            </div>
          )
        })}
      </div>

      {/* RIGHE ESPANSE: attenzione, stessa larghezza colonne, NESSUN paddingLeft */}
      {expanded &&
        rowData.children &&
        rowData.children.map((child, idx) => (
          <div key={`child-${idx}`} className={styles.expandedRow}>
            {columns.map((col, i) => {
              const DataRenderer = col.data
              return (
                <div
                  key={`child-col-${i}`}
                  style={{
                    ...col.style,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box', // importante per larghezza
                  }}
                  className={col.className}>
                  {typeof DataRenderer === 'string' ? (
                    child[DataRenderer]
                  ) : typeof DataRenderer === 'function' ? (
                    <DataRenderer rowData={child} />
                  ) : null}
                </div>
              )
            })}
          </div>
        ))}
    </>
  )
}
